import { quickStats } from "@/mocks/civicData";

export default function About() {
  return (
    <section id="about" className="scroll-mt-24 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <div>
            <p className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span>
              关于本指南
            </p>
            <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              什么是“朝阳群众”式
              <br className="hidden md:block" />
              平安共治？
            </h2>
            <p className="mt-6 text-base leading-8 text-foreground-600">
              “朝阳群众”泛指积极参与社会治安维护、主动向公安机关与政府部门反映线索的广大市民群体。他们把对家园的关心，转化为一次次及时、如实的信息提供与配合核查。
            </p>
            <p className="mt-4 text-base leading-8 text-foreground-600">
              本指南不是授权或代办平台，而是为你整理“去哪反映、如何反映、注意什么”的信息说明。帮助你在合法、理性和保密的框架内，用最小的成本让身边问题被看见、被处理。
            </p>
            <p className="mt-4 text-base leading-8 text-foreground-600">
              共建共治共享，不是少数人的责任，而是每一位普通人的日常参与。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {quickStats.map((s) => (
              <div
                key={s.label}
                className="rounded-2xl border border-background-200 bg-background-100 p-6"
              >
                <p className="text-sm font-medium text-foreground-500">{s.label}</p>
                <p className="mt-3 font-heading text-3xl font-bold text-primary-600">
                  {s.value}
                </p>
                <p className="mt-2 text-sm text-foreground-600">{s.note}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}